// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f9","message":"f-","close":"f_","closeMessage":"ha","closeIcon":"hb"};